import { render, staticRenderFns } from "./smallCaseTitle.vue?vue&type=template&id=564d5b9f&lang=pug"
import script from "./smallCaseTitle.vue?vue&type=script&lang=js"
export * from "./smallCaseTitle.vue?vue&type=script&lang=js"
import style0 from "./smallCaseTitle.vue?vue&type=style&index=0&id=564d5b9f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports